module.exports = __webpack_public_path__ + "img/customNoAct.8d6f420c.png";